// var absolutePath = (href: string) => {
// 	var link = document.createElement('a');
// 	link.href = href;
// 	return link.href;
// };
/**
 * Base URL must come from the script that loads the app (the host of the webcomponent),
 * not from the consumer page. If we cannot determine it, the app must not start.
 */
function getBaseUrlFromScript(): string {
	const script = document.currentScript;
	if (!script?.getAttribute) {
		throw new Error(
			'Chat app: cannot start without document.currentScript (base URL of the script host is required)',
		);
	}
	const src = script.getAttribute('src');
	if (!src) {
		throw new Error(
			'Chat app: cannot start without script src (base URL of the script host is required)',
		);
	}
	const url = new URL(src, document.location.href).href;
	const base = url.split('/static')[0];
	if (!base) {
		throw new Error(
			'Chat app: cannot derive base URL from script src (expected path containing /static)',
		);
	}
	return base.endsWith('/') ? base : base + '/';
}

const baseUrl = getBaseUrlFromScript();
__webpack_public_path__ = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';

require('./webcomponent').renderWebcomponent(baseUrl);

export {};
